__turbopack_context__.v({
  "description": "_NaGQq_description",
  "descriptionWrapper": "_NaGQq_descriptionWrapper",
  "error": "_NaGQq_error",
  "input": "_NaGQq_input",
  "label": "_NaGQq_label",
  "required": "_NaGQq_required",
  "root": "_NaGQq_root",
  "section": "_NaGQq_section",
  "urlEmpty": "_NaGQq_urlEmpty",
  "wrapper": "_NaGQq_wrapper",
});
